export default "__VITE_ASSET__Dmqb0A1a__"